export var LinkText = /*#__PURE__*/function (LinkText) {
  LinkText["TERMS_AND_PRIVACY_POLICY"] = "terms and privacy policy";
  LinkText["MY_ACCOUNT"] = "my account";
  LinkText["COUPON_CTA_CLICKED"] = "Coupon CTA Clicked";
  LinkText["COUPON_ENTERED"] = "Coupon Entered";
  LinkText["COUPON_APPLIED"] = "Coupon Applied";
  LinkText["COUPON_REMOVED"] = "Coupon Removed";
  LinkText["RESUME_SUBSCRIPTION"] = "Resume Subscription";
  LinkText["RESTART_SUBSCRIPTION"] = "Restart Subscription";
  LinkText["CLICK_BACK"] = "clicks back";
  LinkText["REVIEW_ORDER"] = "review order";
  LinkText["JOIN_NOW"] = "join now";
  LinkText["RESUBSCRIBE"] = "resubscribe";
  LinkText["SUBSCRIBE"] = "subscribe";
  return LinkText;
}({});
export var SubType = /*#__PURE__*/function (SubType) {
  SubType["CLICK"] = "click";
  SubType["TEXT"] = "text";
  SubType["TYPED"] = "typed";
  SubType["ERROR"] = "error";
  SubType["COMPONENT"] = "component";
  SubType["INFO"] = "info";
  SubType["RADIO"] = "radio";
  SubType["BUTTON"] = "button";
  SubType["DROPDOWN"] = "drop down";
  SubType["SELECT"] = "select";
  SubType["LINK"] = "link";
  return SubType;
}({});
export var InfoText = /*#__PURE__*/function (InfoText) {
  InfoText["ZIPCODE_INPUT"] = "User Inputs Zip Code In User Address Component";
  InfoText["ZIP_ERROR"] = "Form Error In Field Zip Code On User Address Component";
  return InfoText;
}({});
export var ElementType = /*#__PURE__*/function (ElementType) {
  ElementType["LINK"] = "link";
  ElementType["BUTTON"] = "button";
  ElementType["RADIO"] = "radio";
  ElementType["COMPONENT"] = "component";
  ElementType["CHECKBOX"] = "checkbox";
  ElementType["COLOR"] = "color";
  ElementType["DATE"] = "date";
  ElementType["EMAIL"] = "email";
  ElementType["FILE"] = "file";
  ElementType["PASSWORD"] = "password";
  ElementType["TEXT"] = "text";
  ElementType["TEXTAREA"] = "textarea";
  ElementType["SELECT"] = "select";
  ElementType["DROPDOWN"] = "drop down";
  ElementType["COMBOBOX"] = "combo box";
  ElementType["BANNER"] = "banner";
  ElementType["VIDEO_PLAYER"] = "video player";
  ElementType["AD_SLOT"] = "ad slot";
  ElementType["ICON"] = "icon";
  ElementType["PERSONALIZED"] = "personalized recommendation";
  ElementType["TAB"] = "tab";
  ElementType["RECOMMENDATION"] = "recommendation";
  ElementType["PUSH_NOTIF"] = "push notification";
  ElementType["FEATURED"] = "featured";
  return ElementType;
}({});
export var SuccessText = /*#__PURE__*/function (SuccessText) {
  SuccessText["COUPON_SUCCESSFUL"] = "Coupon Successful";
  SuccessText["SUBSCRIPTION_RESUMED"] = "Subscription Resumed";
  SuccessText["SUBSCRIPTION_RESTART"] = "Subscription Restarted";
  SuccessText["SUBSCRIPTION_RESUBSCRIBED"] = "Subscription Resubscribed";
  SuccessText["SUBSCRIPTION_UPGRADED"] = "Subscription Upgraded";
  SuccessText["SUBSCRIPTION_SUBSCRIBED"] = "Subscription Subscribed";
  return SuccessText;
}({});
export var CouponErrorText = /*#__PURE__*/function (CouponErrorText) {
  CouponErrorText["NON_APPLICABLE"] = "Non-Applicable Coupon Error";
  CouponErrorText["INVALID"] = "Invalid Coupon Error";
  return CouponErrorText;
}({});
export var SpecType = /*#__PURE__*/function (SpecType) {
  SpecType["COMPONENT_VIEW"] = "clickstream_component_view";
  SpecType["INTERACTION"] = "clickstream_interaction";
  SpecType["SUCCESS"] = "clickstream_success";
  SpecType["NOTIFICATION"] = "clickstream_notifications";
  SpecType["PURCHASE"] = "clickstream_purchase";
  SpecType["PAGE_VIEW"] = "clickstream_view";
  return SpecType;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/RioUtils/interfaces.js
// module id = 256
// module chunks = 11